import get from 'lodash.get';

const getAvailablePaymentMethods = (rootState) =>
  get(rootState, 'user.partnerData.properties.availablePaymentMethods', []);

export default getAvailablePaymentMethods;
